export class XhqBillCfmState {
  constructor(code, englishName, chineseName) {
    this.code = code
    this.chineseName = chineseName
    this.englishName = englishName
  }
}

export const CFM_BILL_STATE_NEW = new XhqBillCfmState(1, 'new', '新增')
export const CFM_BILL_STATE_UPDATE = new XhqBillCfmState(2, 'update', '修改')
export const CFM_BILL_STATE_RELEASE = new XhqBillCfmState(3, 'release', '放行')
